<template>
  <div class="modal fade" id="promotionadd" role="dialog" @click="$emit('close')" :style="{ 'z-index': zIndex || 1050 }">
    <div class="modal-dialog modal-xl" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <div class="alert alert-danger text-center p-xxs m-b-xs" v-if="countData === 0">
            <h5 class="m-b-none"><router-link :to="{path: '/products-new'}">こちら</router-link>から商品登録をしてください。</h5>
          </div>
          <div>
            <div class="panel products-table" ref="promotionModal" style="position: relative">
              <base-table
                :url="'PromotionProduct/available'"
                :extraUrl="['Product/get-image-name']"
                :extraUrlMode="true"
                :columns="promotionColumns"
                :isSearchable="true"
                :needExtraData="true"
                :loadingTableMode="true"
                :clientMode="true"
                :checkedItems="checkedItems"
                :isShowBtnBulkCreate="true"
                ref="promotionTable"
                @countData="countData = $event"
                @extraData="extraData = $event"
                @keyword="onHandleSearch"
                @zIndex="zIndex = $event"
                @checkBoxAll="checkBoxAll"
                @bulkAdd="bulkAddPromotion"
              >
                <template slot="checkBoxAll" slot-scope="props">
                  <input type="checkbox" :value="props.rowData.asin" v-model="checkedItems" @change="refreshCheckAll">
                </template>
                <template slot="image" slot-scope="props">
                  <loading-block :value="props.rowData.image" type="image">
                    <img :src="prepareImgSrc(props.rowData.image)" class="product-img"/>
                  </loading-block>
                </template>
                <template slot="productName" slot-scope="props">
                  <loading-block :value="props.rowData.productName" type="string">
                    <a class="text--underline" :href="'https://www.amazon.co.jp/gp/offer-listing/' + props.rowData.asin" target="_blank">
                      {{props.rowData.productName}}
                    </a>
                  </loading-block>
                </template>
                <template slot="action" slot-scope="props">
                  <button class="btn btn-warning" @click="addPromotion(props.rowData)">追加</button>
                </template>
              </base-table>
              <div class="row m-b-sm">
                <div class="flexbox justify-right">
                  <button class="btn btn-warning ver-middle w-120 mr-r-10" @click="onHandleReload">
                    再読み込み
                  </button>
                  <div data-dismiss="modal" @click="$emit('close')">
                    <button class="btn ver-middle w-120">閉じる</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseTable from '@/components/BaseTable'
import LoadingBlock from '@/components/LoadingBlock'
import PromotionService from '@/services/promotionservice'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    BaseTable,
    LoadingBlock
  },

  data () {
    return {
      error: null,
      loader: null,
      zIndex: null,
      countData: null,
      extraData: null,
      keyword: null,
      promotionColumns: [
        {
          title: '<input type="checkbox" id="checkbox-all">',
          name: 'checkBoxAll',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-30 th-checkbox-all',
          sortable: false
        },
        {
          title: '画像',
          name: 'image',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-130',
          sortable: false
        },
        {
          title: 'ASIN',
          name: 'asin',
          cellClass: 'text-center',
          headerClass: 'w-150'
        },
        {
          title: '商品名',
          name: 'productName',
          cellClass: 'text-left',
          customCell: true,
          headerClass: 'product-name'
        },
        {
          title: '',
          name: 'action',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-100',
          sortable: false
        }
      ],
      checkedItems: []
    }
  },

  computed: {
    ...mapGetters({
      isShowModal: 'getIsShowModal'
    })
  },

  watch: {
    isShowModal (newVal, oldVal) {
      if (!newVal && this.zIndex) {
        this.zIndex = null
      }
    },
    countData (newVal, oldVal) {
      this.$emit('checkAvailableItem', newVal, this.keyword)
    },
    keyword (newVal, oldVal) {
      this.$emit('checkAvailableItem', this.countData, newVal)
    },
    isShow (newVal) {
      if (!newVal && !this.isLoadingButton) {
        this.$refs.promotionTable.reload(false, false, false, true)
      }
    }
  },

  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    isLoadingButton: {
      type: Boolean
    }
  },

  mounted () {
    $('#promotionadd').modal('show')
    this.$events.listen('done', (url) => {
      url === 'PromotionProduct/available' && this.loader && this.loader.hide()
    })
  },

  methods: {
    prepareImgSrc (value) {
      return value || `${process.env.NODE_DOMAIN}/static/dists/img/noimg.png`
    },
    addPromotion (item) {
      const payload = {
        record: {
          asin: item.asin
        }
      }
      let logParams = {
        name: eventCode.promotion.request_tab.add_by_amazon_modal.click_add_button,
        properties: {
          product_asin: item.asin
        }
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show({
        container: this.$refs.promotionModal
      })
      PromotionService.addPromotionProduct(payload)
        .then(response => {
          this.$refs.promotionTable.handleData(item, 'delete')
          this.checkedItems = this.checkedItems.filter(checkedItemAsin => checkedItemAsin !== item.asin)
          this.$emit('isAddPromotion')
          this.zIndex = null
          this.loader && this.loader.hide()
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
          this.zIndex = 1040
          this.loader && this.loader.hide()
          this.err = error
        })
    },
    onHandleReload () {
      let logParams = {
        name: eventCode.promotion.request_tab.add_by_amazon_modal.click_reload_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.$emit('toggleButton', true)
      this.$refs.promotionTable.reload(true)
    },

    formatAmount (value) {
      return (value === null || typeof value === 'undefined') ? '' : `¥${Util.formatMoney(value)}`
    },

    sortExpectedAmount (data, order) {
      if (!order) {
        return [...data]
      } else if (order === 'desc') {
        return [...data].sort((before, after) => before.offerPrice - after.offerPrice)
      }
      return [...data].sort((before, after) => after.offerPrice - before.offerPrice)
    },
    onHandleSearch (keywordValue) {
      this.keyword = keywordValue
      let logParams = {
        name: eventCode.promotion.request_tab.add_by_amazon_modal.click_filter_button,
        properties: {
          keyword: keywordValue
        }
      }
      EventService.postTrackLog(logParams)
    },
    refreshCheckAll () {
      const items = this.$refs.promotionTable.pageData
      if (this.checkedItems.length === items.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    checkBoxAll (value) {
      const items = this.$refs.promotionTable.pageData
      this.checkAll = value
      this.checkedItems = []
      var _self = this
      if (this.checkAll) {
        items.forEach(function (item) {
          _self.checkedItems.push(item.asin)
        })
      }
    },
    bulkAddPromotion () {
      const payload = {
        asins: this.checkedItems
      }

      let logParams = {
        name: eventCode.promotion.request_tab.add_by_amazon_modal.click_add_all_button,
        properties: payload
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show({
        container: this.$refs.promotionModal
      })
      PromotionService.addPromotionProducts(payload)
        .then(response => {
          this.$refs.promotionTable.handleData(payload.asins, 'deleteAll')
          this.$emit('isAddPromotion')
          this.zIndex = null
          this.checkAll = false
          this.checkedItems = []
          this.loader && this.loader.hide()
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
          this.zIndex = 1040
          this.loader && this.loader.hide()
          this.err = error
        })
    }
  },

  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
  #promotionadd /deep/ .box-base-table-search {
    display: block;
    justify-content: unset;
    align-items: unset;
    flex-wrap: unset;
  }
  #promotionadd /deep/ .box-base-table-search .search-multiple {
    flex-grow: unset;
    margin-right: unset;
    display: flex;
    align-items: center;
  }
  #promotionadd /deep/ .box-base-table-search .search-multiple input {
    margin-right: 30px;
  }
  #promotionadd /deep/ .th-checkbox-all {
    padding: 6px;
    position: relative;
  }
  #promotionadd /deep/ .th-checkbox-all input {
    position: absolute;
    top: 8px;
    left: 0;
    right: 0;
  }
  @media (max-width: 1200px) {
    #promotionadd /deep/ .box-base-table-search .sale-detail-search {
      display: block;
      justify-content: unset;
    }

    #promotionadd /deep/ .box-base-table-search .sale-detail-search .search-block {
      display: flex;
      margin-bottom: 10px;
      margin-right: 0;
    }
    #promotionadd /deep/ .box-base-table-search .sale-detail-search .search-block label {
      width: 68px;
      margin-right: 0;
    }
    #promotionadd /deep/ .box-base-table-search .sale-detail-search .search-block input[name="detail"] {
      width: 184px;
    }
    #promotionadd /deep/ .box-base-table-search .sale-detail-search .search-block select[name="mallCode"] {
      width: 184px;
    }
    #promotionadd /deep/ .box-base-table-search .sale-detail-search .box-detail-btn-search {
      margin-left: 68px;
    }
  }
  @media (min-width: 1200px) {
    #promotionadd /deep/ .box-base-table-search .sale-detail-search {
      margin-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/promotion/PromotionAdd.vue